import React from 'react';

import DataTableLimit from './DataTableLimit';
import DataTablePagination from './DataTablePagination';

import './DataTable.scss';
import InputCurrencyField from './InputCurrencyField';

class DataTable extends React.Component {
  _getColumnHeadingClickHandler = columnId => {
    return () => {
      const { sortedBy, onSortRequest } = this.props;

      let data = null;
      if (!sortedBy || sortedBy.columnId !== columnId) {
        data = { columnId: columnId, direction: 'ASC' };
      }
      else if (sortedBy.columnId === columnId && sortedBy.direction === 'ASC') {
        data = { columnId: columnId, direction: 'DESC' };
      }

      onSortRequest(data);
    };
  }

  handleLimitChange = value => {
    this.props.onLimitChange(value);
  }

  handleCurrentPageChange = value => {
    this.props.onPageChange(value);
  }

  renderColumnHeadings(columns) {
    const { sortedBy, onSelectAll, isAllSelected, showCheckbox, selectedItems } = this.props;
    const selected = selectedItems?.filter(i => i.isSelected)
    return (
      <React.Fragment>
        {showCheckbox && <th className="table-header-checkbox"><input className="header-checkbox" type="checkbox" checked={isAllSelected && selectedItems.length === selected.length} onChange={(e) => onSelectAll(e)} /></th>}
        {columns.map(column => {
          const columnClasses = [`column--${column.id}`];

          const isSorted = (sortedBy && sortedBy.columnId === column.id);
          const sortDirection = (isSorted) ? sortedBy.direction.toLowerCase() : null;

          const headingClasses = ['parkchirp--data-table--column-heading'];
          if (isSorted) {
            headingClasses.push(`column-sort--${sortDirection}`);
          }

          return (
            <th key={column.id} className={columnClasses.join(' ')}>
              <span
                className={headingClasses.join(' ')}
                onClick={this._getColumnHeadingClickHandler(column.id)}>
                {column.heading}
                {(isSorted && sortDirection === 'asc') &&
                  <span className={`parkchirp--data-table--column-heading-sort-icon
                    parkchirp--data-table--column-heading-sort-icon--asc`}
                  >&#9650;</span>
                }
                {(isSorted && sortDirection === 'desc') &&
                  <span className={`parkchirp--data-table--column-heading-sort-icon
                    parkchirp--data-table--column-heading-sort-icon--desc`}
                  >&#9660;</span>
                }
              </span>
            </th>
          );
        })}
      </React.Fragment>
    );
  }

  renderDataRows(columns, rows) {
    const { selectedItems, showCheckbox, onItemCheck, noRecordsText, onInputFieldChange, editable } = this.props;
    return (
      <React.Fragment>
        {noRecordsText && 
          <div className="parkchirp--data-table--no-data">
            {noRecordsText}
          </div>
        }
        {(rows && rows.length > 0) && rows.map((row, index) =>
          <tr key={index}>
            {showCheckbox && <td><input checked={selectedItems[index].isSelected} onChange={(e) => {onItemCheck(e, index)}} type="checkbox" /></td>}
            {row.map((cell, ind) => {
              return editable && showCheckbox && selectedItems[index]?.isSelected && ind === row.length - 1 ? 
              <InputCurrencyField
              value={cell}
              onChange={(value) => onInputFieldChange(index, value)}
              editMode={true}
            /> :
              typeof cell === 'object' ? <td>{cell}</td> :
                <td className={`column--${columns[ind]?.id}`} key={ind} dangerouslySetInnerHTML={{ __html: cell }}></td>
            })}
          </tr>)
        }
      </React.Fragment>
    );
  }

  render() {
    const {
      id,
      columns,
      rows,
      overallRowCount,
      currentOffset,
      currentLimit,
      limitOptions,
      noRecordsText,
      displayDataTablelimit
    }  = this.props;

    // Making use of the WordPress admin theme table classes for now.
    const tableClasses = ['parkchirp--data-table--table', 'widefat', 'fixed', 'striped'];

    const displayPagination = (currentLimit !== null) && (overallRowCount > rows.length);

    return (
      <div className={`parkchirp--data-table parkchirp--data-table--${id}`}>
        {((!rows || !rows.length) && !noRecordsText) &&
          <div className="parkchirp--data-table--user-message-container">
            <p className="parkchirp--data-table--user-message">No records.</p>
          </div>
        }
        {((rows && rows.length > 0) || noRecordsText) &&
          <React.Fragment>
            <table className={tableClasses.join(' ')}>
              <thead>
                <tr>{this.renderColumnHeadings(columns)}</tr>
              </thead>
              <tbody>{this.renderDataRows(columns, rows)}</tbody>
            </table>
            <div className="parkchirp--data-table--options-container">
              {!displayDataTablelimit &&
                <DataTableLimit
                  dataTableId={id}
                  value={currentLimit}
                  options={limitOptions || null}
                  onChange={this.handleLimitChange}
                />
              }
              {displayPagination &&
                <DataTablePagination
                  dataTableId={id}
                  overallRowCount={overallRowCount}
                  offset={currentOffset}
                  limit={currentLimit}
                  onChange={this.handleCurrentPageChange}
                />
              }
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}

export default DataTable;
